import React, { useState } from "react"
import Display from "./Display"
import { Typography, Box, Button, Card, Slider } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"

import "./Calculator.css"
import "react-input-range/lib/css/index.css"

const CalculatorButton = withStyles({
  root: {
    marginRight: 8,
    borderRadius: 4,
  },
})(Button)

const CalculatorSlider = withStyles({
  root: {
    color: "#291C6",
    height: 10,
    padding: "8px 0",
    width: "100%",
  },
  thumb: {
    height: 20,
    width: 20,
    marginTop: -8,
    marginLeft: -12,
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 6px)",
    top: 32,
    textAlign: "center",
    fontSize: "18px !important",
    fontWeight: 600,
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
  track: {
    height: 4,
  },
  rail: {
    height: 4,
    opacity: 0.5,
    backgroundColor: "#bfbfbf",
  },
  mark: {
    backgroundColor: "#bfbfbf",
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markLabel: {
    top: 51,
  },
  markActive: {
    opacity: 1,
    backgroundColor: "currentColor",
  },
})(Slider)

const investmentProducts = {
  acceso: {
    name: "ACCESO",
    interest: 2.5,
    typeTime: "Días",
    min: 30,
    max: 365,
    step: 30,
  },
  uno: {
    name: "UNO",
    interest: 8,
    typeTime: "Años",
    min: 1,
    max: 4,
    step: 1,
  },
  mercado: {
    name: "MERCADO",
    interest: 9,
    typeTime: "Años",
    min: 3,
    max: 12,
    step: 3,
  },
}
function Calculator() {
  const [amountValue, setAmountValue] = useState(10000)
  const [timeValue, setTimeValue] = useState(investmentProducts.acceso.min)
  const [investmentProduct, setInvestmentProductChange] = useState(
    investmentProducts.acceso
  )

  const handleInvestmentProductChange = investmet => {
    setInvestmentProductChange(investmet)
    setTimeValue(investmet.min)
  }

  const handleChangeAmount = (event, amountValue) => {
    setAmountValue(amountValue)
  }

  const handleChangeTime = (event, timeValue) => {
    setTimeValue(timeValue)
  }

  return (
    <Card raised style={{ marginBottom: "16px", width: "100%" }}>
      <Box py={4} px={4}>
        <Typography variant="h3" align="center" gutterBottom>
          Calcula <strong>tu inversión</strong>
        </Typography>
        <Typography
          variant="body2"
          id="amount-value"
          gutterBottom
          style={{ paddingTop: 16 }}
        >
          ¿Qué monto deseas invertir?
        </Typography>
        <CalculatorSlider
          value={amountValue}
          defaultValue={1000}
          aria-labelledby="amount-value"
          step={100}
          min={20}
          max={100000}
          marks={[{ value: 100000, label: "MXN" }]}
          valueLabelDisplay="on"
          onChange={handleChangeAmount}
        />
        <Typography
          variant="body2"
          id="years-value"
          gutterBottom
          style={{ paddingTop: 24 }}
        >
          ¿Por cuánto tiempo?
        </Typography>
        <CalculatorSlider
          defaultValue={1}
          value={timeValue}
          aria-labelledby="years-value"
          step={investmentProduct.step}
          min={investmentProduct.min}
          max={investmentProduct.max}
          marks={[
            { value: investmentProduct.max, label: investmentProduct.typeTime },
          ]}
          valueLabelDisplay="on"
          onChange={handleChangeTime}
        />
        <Typography
          variant="body2"
          id="years-value"
          gutterBottom
          style={{ paddingTop: 24 }}
        >
          ¿Qué porcentaje de interés anual deseas?
        </Typography>
        <Box display="flex" justifyContent="flex-start" pb={2}>
          <CalculatorButton
            size="small"
            variant={`${
              investmentProduct.name === "ACCESO" ? "contained" : "outlined"
            }`}
            color="primary"
            value={investmentProducts.acceso.interest}
            onClick={() =>
              handleInvestmentProductChange(investmentProducts.acceso)
            }
          >
            2.5%
          </CalculatorButton>
          <CalculatorButton
            size="small"
            variant={`${
              investmentProduct.name === "UNO" ? "contained" : "outlined"
            }`}
            color="primary"
            value={investmentProducts.uno.interest}
            onClick={() =>
              handleInvestmentProductChange(investmentProducts.uno)
            }
          >
            8.0%
          </CalculatorButton>
          <CalculatorButton
            size="small"
            variant={`${
              investmentProduct.name === "MERCADO" ? "contained" : "outlined"
            }`}
            color="primary"
            value={investmentProducts.mercado.interest}
            onClick={() =>
              handleInvestmentProductChange(investmentProducts.mercado)
            }
          >
            9.0%
          </CalculatorButton>
        </Box>
        <Display
          name={investmentProduct.name}
          years={timeValue}
          amount={amountValue}
          interest={investmentProduct.interest}
        />
      </Box>
    </Card>
  )
}

export default Calculator
